import React, { useContext } from "react";
import "./Celebrate_The_Festival.css";
import Festival_Product_Card from "../../../common_components/festival_product_card/Festival_Product_Card";
import Common_Title from "../../../common_components/common_title/Common_Title";
import { Context } from "../../../../utils/context";
import { encodeId } from "../../../../utils/common";

const Celebrate_The_Festival = ({ occasions, giftoccassions }) => {
  const { IMG_URL } = useContext(Context);
  return (
    <section className="Celebrate_The_Festival">
      <Common_Title
        pageTitle=/*{"GIFT THE GLOW OF DIWALI!"}*/ {giftoccassions?.name}
        subTitle=/*{
          "Celebrate the festival of lights with gifts that shine as bright as your love."
        }*/ {
          giftoccassions?.sub_name
        }
      />

      <div className="row">
        <div className="col-12 p-sm-2 p-1">
          <div className="main_img_holder">
            <Festival_Product_Card
              imgSrc={
                IMG_URL + giftoccassions?.image ||
                "/assest/luxury_images/festival_products/img1.png"
              }
              // text={"View All"}
              url={`/luxury/products`}
            />
          </div>
        </div>
        {giftoccassions?.gift_occassion_multiples?.slice(0, 4)?.map((data) => (
          <div key={data.id} className="col-sm-3 col-3 p-sm-2 p-1">
            <Festival_Product_Card
              imgSrc={IMG_URL + data?.product?.image1}
              url={`/luxury/product-details/${encodeId(data?.product?.id)}`}
              text={data?.product?.name}
            />
          </div>
        ))}
        {/* <div className="col-sm-4 col-4 p-sm-2 p-1">
          <Festival_Product_Card
            imgSrc={"/assest/luxury_images/festival_products/img2.png"}
          />
        </div> */}
      </div>
    </section>
  );
};

export default Celebrate_The_Festival;
